import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAuth, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebaseConfig';
import './StripePages.css';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('ready');
  const [message, setMessage] = useState('Enter your new password');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const oobCode = searchParams.get('oobCode');
    
    if (!oobCode) {
      setStatus('error');
      setMessage('Invalid reset link');
    }
  }, [searchParams]);

  const handleReset = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      setMessage('Password must be at least 6 characters');
      return;
    }

    setSaving(true);
    const oobCode = searchParams.get('oobCode');
    
    try {
      const app = initializeApp(firebaseConfig);
      const auth = getAuth(app);
      
      await verifyPasswordResetCode(auth, oobCode);
      await confirmPasswordReset(auth, oobCode, newPassword);
      
      setStatus('success');
      setMessage('Password reset successfully!');
    } catch (error) {
      console.error('Reset error:', error);
      setMessage(error.message || 'Failed to reset password');
    } finally {
      setSaving(false);
    }
  };

  if (status === 'success') {
    return (
      <div className="stripe-page-container">
        <div className="stripe-card success">
          <div className="stripe-icon">✓</div>
          <h1>Success!</h1>
          <p>{message}</p>
          <button 
            className="primary-button"
            onClick={() => window.location.href = 'https://app.fodyfee.com/login'}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="stripe-page-container">
        <div className="stripe-card error">
          <div className="stripe-icon">✗</div>
          <h1>Error</h1>
          <p>{message}</p>
          <button 
            className="primary-button"
            onClick={() => window.location.href = 'https://app.fodyfee.com/login'}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="stripe-page-container">
      <div className="stripe-card verifying">
        <div className="stripe-icon" style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>🔒</div>
        <h1>Reset Password</h1>
        <p>{message}</p>
        
        <form onSubmit={handleReset}>
          <input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '16px',
              marginBottom: '12px',
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
              fontSize: '16px',
            }}
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '16px',
              marginBottom: '24px',
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
              fontSize: '16px',
            }}
          />
          <button 
            type="submit"
            className="primary-button"
            disabled={saving}
          >
            {saving ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordPage;